<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 19"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.706956 8.48592C1.09748 8.09539 1.73064 8.09539 2.12117 8.48592L9.89834 16.2631C10.2889 16.6536 10.2889 17.2868 9.89834 17.6773C9.50782 18.0678 8.87465 18.0678 8.48413 17.6773L0.706954 9.90013C0.31643 9.5096 0.316431 8.87644 0.706956 8.48592Z" :fill="fill"/>
    <rect :fill="fill" height="2" rx="1" transform="rotate(135 10.6074 1.41406)" width="13.0007" x="10.6074" y="1.41406"/>
    <rect :fill="fill" height="2" rx="1" transform="rotate(90 24 0)" width="18" x="24"/>
    <rect :fill="fill" height="2" rx="0.999999" transform="rotate(-180 16 10)" width="15" x="16" y="10"/>
  </svg>
</template>

<script>
export default {
  name: 'ArrowLeftCollapse',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
